module.exports = __webpack_public_path__ + "static/media/parejas4.4301c92b.jpg";